// extracted by mini-css-extract-plugin
module.exports = {"versionSticker":"VersionSticker_versionSticker__sZ9KG"};